const getState = () => ({

});

export default getState;
